import React from 'react';
import { SC } from '../../styles/theme';
import { BRAND, isMarketGB } from '../../constants/main';
import { CheckoutAssistedFinanceStyledAC } from './AC/CheckoutAssistedFinanceStyled.AC';
import { CheckoutAssistedFinanceStyledOV } from './OV/CheckoutAssistedFinanceStyled.OV';
import { CheckoutAssistedFinanceStyledGBOV } from './OV/GB/CheckoutAssistedFinanceStyled.OV';
import { CheckoutAssistedFinanceStyledAP } from './AP/CheckoutAssistedFinanceStyled.AP';
import { CheckoutAssistedFinanceStyledDS } from './DS/CheckoutAssistedFinanceStyled.DS';
import { CheckoutAssistedFinanceStyled } from './CheckoutAssistedFinanceStyled';

export interface ICheckoutFinanceProps {
    isConfirmationPage?: boolean;
}

export type Props = SC & ICheckoutFinanceProps;

const CheckoutCarMainInfo = (props: Props) => {
    if (BRAND === 'OV')
        return isMarketGB ? <CheckoutAssistedFinanceStyledGBOV {...props} /> : <CheckoutAssistedFinanceStyledOV {...props} />;
    if (BRAND === 'AC') return <CheckoutAssistedFinanceStyledAC {...props} />;
    if (BRAND === 'AP') return <CheckoutAssistedFinanceStyledAP {...props} />;
    if (BRAND === 'DS') return <CheckoutAssistedFinanceStyledDS {...props} />;
    return <CheckoutAssistedFinanceStyled {...props} />;
};

export default CheckoutCarMainInfo;
